export const apiCalculatedAttributesIdAppGroupIdUserLookup =
  "/api/calculated_attributes/:id/:app_group_id/user_lookup";
